import React
, { useState }// {useEffect}
 from 'react';
 import ContractForm from './ContractForm';
import { Trash2, SquarePen, Eye, Plus } from 'lucide-react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
} from '@chakra-ui/react'
import {  Link } from 'react-router-dom';
import './ContractFinance.css';


function ContractList() {
  const [isDrawerOpen,setIsDrawerOpen] = useState(false);

  const openDrawer = ()=>{
    setIsDrawerOpen(true)
  }
  const closeDrawer = ()=>{
    setIsDrawerOpen(false)
  }
  const heading = [
    { th: <Checkbox key="checkbox" /> },
    { th: 'Actions' },
    { th: 'Customer Name' },
    { th: 'Estimate' },
    { th: 'Reference' },
    { th: 'Estimate Date' },
    { th: 'Expiry Date' },
    { th: 'Salesperson' },
    { th: 'Project Name' },
    { th: 'Recurring S/O Date' },
    { th: 'Franchisee Account' },
    { th: 'Job Type' },
    { th: 'Working Days' },
    { th: 'Frequency' },
  ];

  const [formData,setFormData] = useState(
    {
      customername:'',
      estimate:'',
      reference:'',
      estimatedate:'',
      expirydate:'',
      salesperson:'',
      projectname:'',
      recurringsOsdate:'',
      franchiseeaccount:'',
      jobtype:'',
      workingdays:'',
      frequency:''
    
    })
    const Data = [
      {
        customername: 'ABC Company',
        estimate: 'Estimate #001',
        reference: 'REF-001',
        estimatedate: '2024-07-16',
        expirydate: '2024-08-16',
        salesperson: 'John Doe',
        projectname: 'Project X',
        recurringsOsdate: '2024-07-20',
        franchiseeaccount: 'Franchise A',
        jobtype: 'Design',
        workingdays: '5',
        frequency: 'Monthly'
      },
      {
        customername: 'XYZ Corporation',
        estimate: 'Estimate #002',
        reference: 'REF-002',
        estimatedate: '2024-07-18',
        expirydate: '2024-08-18',
        salesperson: 'Jane Smith',
        projectname: 'Project Y',
        recurringsOsdate: '2024-07-22',
        franchiseeaccount: 'Franchise B',
        jobtype: 'Development',
        workingdays: '3',
        frequency: 'Weekly'
      },
      {
        customername: 'PQR Ltd.',
        estimate: 'Estimate #003',
        reference: 'REF-003',
        estimatedate: '2024-07-20',
        expirydate: '2024-08-20',
        salesperson: 'Mike Johnson',
        projectname: 'Project Z',
        recurringsOsdate: '2024-07-25',
        franchiseeaccount: 'Franchise C',
        jobtype: 'Testing',
        workingdays: '4',
        frequency: 'Quarterly'
      },
      {
        customername: 'LMN Enterprises',
        estimate: 'Estimate #004',
        reference: 'REF-004',
        estimatedate: '2024-07-22',
        expirydate: '2024-08-22',
        salesperson: 'Emily Brown',
        projectname: 'Project A',
        recurringsOsdate: '2024-07-28',
        franchiseeaccount: 'Franchise D',
        jobtype: 'Support',
        workingdays: '2',
        frequency: 'Annually'
      },
      {
        customername: 'DEF Industries',
        estimate: 'Estimate #005',
        reference: 'REF-005',
        estimatedate: '2024-07-24',
        expirydate: '2024-08-24',
        salesperson: 'Alex Green',
        projectname: 'Project B',
        recurringsOsdate: '2024-07-30',
        franchiseeaccount: 'Franchise E',
        jobtype: 'Consulting',
        workingdays: '5',
        frequency: 'Bi-weekly'
      }
    ];
  return (
    <>
    
      <div >
      <div className='d-flex justify-content-end' onClick={openDrawer}>
          <button className="new-button mx-2" ><Plus size="18px" /><span className='ms-1' onClick={openDrawer} >New</span></button>
        </div>
        <div className='custom-scroll ' style={{ paddingBottom:'6rem',minHeight: "87vh" }}>
          <TableContainer>
            <Table variant='simple' size='sm'  >
              <Thead>
                <Tr>
                {heading.map((item, index) => (
                    <Th key={index}>{item.th}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
              {Data.map((item, index) => (
        <Tr key={index}>
          <Td><Checkbox /></Td>
          <Td>
            <Tr className="d-flex gap-1">
              <Link to="/candidate-detail-view">
                <i style={{ cursor: 'pointer' }}>
                  <Eye color="#ff176b" size="16px" strokeWidth="1" />
                </i>
              </Link>
              <i onClick={() => { openDrawer(); }} style={{ cursor: 'pointer' }}>
                <SquarePen color="#ff176b" size="16px" strokeWidth="1" />
              </i>
              <i style={{ cursor: 'pointer' }}>
                <Trash2 color="#ff176b" size="16px" strokeWidth="1" />
              </i>
            </Tr>
          </Td>
          <Td>{item.customername}</Td>
          <Td>{item.estimate}</Td>
          <Td>{item.reference}</Td>
          <Td>{item.estimatedate}</Td>
          <Td>{item.expirydate}</Td>
          <Td>{item.salesperson}</Td>
          <Td>{item.projectname}</Td>
          <Td>{item.recurringsOsdate}</Td>
          <Td>{item.franchiseeaccount}</Td>
          <Td>{item.jobtype}</Td>
          <Td>{item.workingdays}</Td>
          <Td>{item.frequency}</Td>
          <Td>{item.creatorid}</Td>
        </Tr>
      ))}
              
              </Tbody>
            </Table>
          </TableContainer>
        </div>
          {/* Pagination */}
          <div className="d-flex align-items-center justify-content-center position-absolute mx-auto" style={{bottom:10,left:"47%"}}>
          {/* <Pagination totalPages={totalPages} onPageChange={setCurrentPage} /> */}
        </div>
        {/* End Pagination */}
        <ContractForm closeDrawer={closeDrawer} isDrawerOpen={isDrawerOpen} />
      </div>
    </>
  )
}

export default ContractList